export default {

    start: function (apiFunction, meantime, doneFunction = (data) => data.done, deadLineTime) {
        // Default end time is set to now + 3 minutes
        const endTimeMS = (deadLineTime) ? deadLineTime : (new Date()).getTime() + 180000
        return new Promise((resolve, reject) => {

            return loop({ apiFunction, meantime, resolve, reject, doneFunction, endTimeMS })

        })

    }

}

async function loop({apiFunction, meantime, resolve, reject, doneFunction, endTimeMS}) {

    apiFunction()
        .then(data => {
            if (doneFunction(data)) {
                return resolve(data)

            } else {

                if (meantime) {

                    meantime(data)

                }

                waiting({apiFunction, meantime, resolve, reject, time: data.retry, doneFunction, endTimeMS})

            }

        })
        .catch(error => {

            reject(error)

        })

}

function waiting({apiFunction, meantime, resolve, reject, time, doneFunction, endTimeMS}) {
    if ( (new Date()).getTime() > endTimeMS) {
        reject({message: 'delayMax reached'})
        return
    }

    setTimeout(function () {

        loop({apiFunction, meantime, resolve, reject, doneFunction, endTimeMS})

    }, time)
}

